export const terminalTypeOptions = [
  'EDSQ',
  'Game Touch 20',
  'Game Touch 28',
  'Gamepoint',
  'Gemini',
  'Gemini Touch',
  'SST',
];

export const keyRequestedOptions = [
  'Door Cylinder Key',
  'Cash Box Key',
  'T-Bar',
  'Key Core',
  'Main Door Key',
  'Bill Acceptor',
  'Security Box Key',
];
